(function () {
  'use strict';

  var NURSERY_IMAGE = 'https://cdn.shopify.com/s/files/1/0644/7916/6582/files/gm-black-nursery-pot-white-800.jpg?v=1785553904';
  var observer = null;
  var scheduled = false;

  function isArabic() {
    return document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';
  }

  function setPresentation(mode) {
    window.gmPotPresentation = mode;
    window.gmPlantPotChoice = {
      mode: mode,
      included: mode === 'nursery',
      selection: mode === 'decorative' ? (window.gmSelectedPot || null) : null
    };
  }

  function unwrapOldChooser(root) {
    var chooser = root.querySelector('#gmPotChoiceStage, .gm-pot-presentation-chooser, .gm-pot-choice-stage');
    if (chooser) chooser.remove();

    var recommendation = root.querySelector('#gmPotRecommendationView');
    if (recommendation) {
      while (recommendation.firstChild) root.insertBefore(recommendation.firstChild, recommendation);
      recommendation.remove();
    }

    root.querySelectorAll('#gmPotChoiceStage, .gm-pot-presentation-chooser, .gm-pot-choice-stage').forEach(function (node) {
      node.remove();
    });
  }

  function normalizeHeading(root) {
    var badge = root.querySelector('#gmPotSizeBadge');
    if (badge) {
      badge.hidden = true;
      badge.textContent = '';
      badge.style.setProperty('display', 'none', 'important');
    }

    var mainHeader = root.querySelector('.gm-pot-header');
    if (mainHeader) mainHeader.style.setProperty('display', 'none', 'important');

    var sectionHead = root.querySelector('#gmStandardSection .gm-pot-section-head');
    var title = root.querySelector('#gmStandardTitle');
    var note = root.querySelector('#gmStandardNote');

    if (sectionHead) {
      sectionHead.style.setProperty('display', 'block', 'important');
      sectionHead.style.setProperty('width', '100%', 'important');
      sectionHead.style.setProperty('margin-bottom', '10px', 'important');
    }

    if (title) {
      title.style.setProperty('display', 'block', 'important');
      title.style.setProperty('width', '100%', 'important');
      title.style.setProperty('white-space', 'nowrap', 'important');
      title.style.setProperty('margin', '0', 'important');
    }

    if (note) {
      note.style.setProperty('display', 'block', 'important');
      note.style.setProperty('width', '100%', 'important');
      note.style.setProperty('margin', '4px 0 0', 'important');
      note.style.setProperty('text-align', 'start', 'important');
    }
  }

  function clearDecorativeSelection() {
    window.gmSelectedPot = null;
    setPresentation('nursery');

    var api = window.GMPotSelectorV2;
    var engine = api && (api.potEngine || api.engine);
    if (engine && typeof engine.clearSelection === 'function') {
      engine.clearSelection();
    } else {
      document.dispatchEvent(new CustomEvent('gm:pot-cleared'));
    }

    if (api && api.renderer && typeof api.renderer.closeOptions === 'function') {
      api.renderer.closeOptions();
    }

    document.querySelectorAll('#gmPotSelector .gm-pot-product-card, #gmPotSelector .gm-pot-variant-card').forEach(function (card) {
      card.classList.remove('active');
    });
  }

  function setNurseryActive(active) {
    document.querySelectorAll('#gmPotSelector .gm-direct-nursery-pot').forEach(function (button) {
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function selectNursery(button) {
    clearDecorativeSelection();
    setNurseryActive(true);
    if (button) button.focus({ preventScroll: true });

    document.dispatchEvent(new CustomEvent('gm:pot-mode-changed', {
      detail: { mode: 'nursery', included: true }
    }));
  }

  function confirmDecorativeSelection() {
    if (!window.gmSelectedPot) return;
    setPresentation('decorative');
    setNurseryActive(false);
  }

  function createNurseryCard() {
    var button = document.createElement('button');
    var name = isArabic() ? 'الأصيص الأسود الأساسي' : 'Black Nursery Pot';
    var price = isArabic() ? 'مشمول مع النبات' : 'Included with plant';

    button.type = 'button';
    button.className = 'gm-pot-product-card gm-direct-nursery-pot';
    button.dataset.handle = '__nursery_pot__';
    button.dataset.category = 'nursery';
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML =
      '<div class="gm-pot-product-image-wrap">' +
        '<img class="gm-pot-product-image" src="' + NURSERY_IMAGE + '" alt="' + name + '" loading="lazy">' +
      '</div>' +
      '<div class="gm-pot-product-name">' + name + '</div>' +
      '<div class="gm-pot-product-price gm-direct-nursery-pot__included">' + price + '</div>';

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      selectNursery(button);
    });

    return button;
  }

  function ensureNurseryCard(root) {
    var grid = root.querySelector('#gmStandardGrid');
    if (!grid) return;

    grid.querySelectorAll('.gm-direct-nursery-pot').forEach(function (node, index) {
      if (index > 0) node.remove();
    });

    var nursery = grid.querySelector('.gm-direct-nursery-pot');
    if (!nursery) {
      nursery = createNurseryCard();
      grid.prepend(nursery);
    } else if (grid.firstElementChild !== nursery) {
      grid.prepend(nursery);
    }

    var hasConfirmedDecorativePot = Boolean(window.gmSelectedPot);
    setNurseryActive(!hasConfirmedDecorativePot);
    setPresentation(hasConfirmedDecorativePot ? 'decorative' : 'nursery');
  }

  function normalize() {
    scheduled = false;
    var root = document.getElementById('gmPotSelector');
    if (!root) return;

    unwrapOldChooser(root);
    normalizeHeading(root);
    ensureNurseryCard(root);
  }

  function scheduleNormalize() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(normalize);
  }

  document.addEventListener('gm:pot-selected', confirmDecorativeSelection);
  document.addEventListener('gm:premium-confirmed', confirmDecorativeSelection);

  document.addEventListener('gm:pot-cleared', function () {
    if (!window.gmSelectedPot) {
      setPresentation('nursery');
      setNurseryActive(true);
    }
  });

  document.addEventListener('gm:pot-selector-updated', scheduleNormalize);
  document.addEventListener('shopify:section:load', scheduleNormalize);
  document.addEventListener('shopify:section:select', scheduleNormalize);

  function start() {
    normalize();
    observer = new MutationObserver(scheduleNormalize);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
